import template from './prems-discount-sales-channel-selector.html.twig';

const { Component, Context } = Shopware;
const { EntityCollection, Criteria } = Shopware.Data;

Component.register('prems-discount-sales-channel-selector', {
    template,
    inheritAttrs: false,

    inject: ['repositoryFactory'],

    props: {
        discountCategory: {
            type: Object,
            required: false,
            default: null
        },
    },
    computed: {
        salesChannelRepository() {
            return this.repositoryFactory.create('sales_channel');
        },
        salesChannelIds: {
            get() {
                this.ensureValueExist();
                return Object.keys(this.discountCategory.discountSalesChannelIds).length > 0 ?  this.discountCategory.discountSalesChannelIds : null;
            },
            set(salesChannelIds) {
                this.ensureValueExist();
                this.discountCategory.discountSalesChannelIds = salesChannelIds;
            }
        },
    },

    created() {
        this.createdComponent();
    },

    data() {
        return {
            salesChannels: null
        };
    },

    methods: {
        createdComponent() {
            this.salesChannels = new EntityCollection(
                this.salesChannelRepository.route,
                this.salesChannelRepository.entityName,
                Context.api
            );

            if (!this.salesChannelIds) {
                return Promise.resolve();
            }

            const criteria = new Criteria();
            criteria.setIds(this.salesChannelIds);

            return this.salesChannelRepository.search(criteria, Context.api).then((salesChannels) => {
                this.salesChannels = salesChannels;
            });
        },
        ensureValueExist() {
            if (typeof this.discountCategory.discountSalesChannelIds === 'undefined' || this.discountCategory.discountSalesChannelIds === null) {
                this.discountCategory.discountSalesChannelIds = {};
            }
        },
        setSalesChannelIds(salesChannels) {
            this.salesChannelIds = salesChannels.getIds();
            this.salesChannels = salesChannels;
        }
    }
});